// extracted by mini-css-extract-plugin
export default {"container":"kQ-z","title":"lQ-z","link":"mQ-z"};